<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class='icon-bell'></i>
      </template>
      <b-list-group class="list-group-accent mensajes">
        <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
          Mensajes
        </b-list-group-item>

        <div v-for="{ id, fechaRegistro, descripcion, leido, ruta, params } in mensajes" :key="id">
          <transition name="slide">
            <b-list-group-item class="list-group-item-accent-warning list-group-item-divider">
              <!-- <div><strong>{{titulo}}</strong></div> -->
              <div class="header">
                <i class="fa fa-circle small" aria-hidden="true" 
                  :class="{ 'leido': leido, 'no-leido': !leido }" 
                  @click="setLeido({ id: id, leido: leido })"></i>
                <p class="text-muted small">{{ fechaRegistro | fechaHora }}</p>
                <i class="fa fa-trash-o small" aria-hidden="true"
                  @click="borrarMensaje(id)"></i>
              </div>
              <div class="content">
                <small class="small mr-3">
                  {{descripcion}}
                </small>
              </div>
              <div class="link" v-if="ruta">
                <small class="small mr-3" @click="goTo({ id: id, leido: leido, ruta: ruta, params: params })">
                <!-- <small class="small mr-3" @click="goTo({ id: id, leido: leido, ruta: 'EvaluacionUsuarioCompletar', params: 'id: 9' })"></small> -->
                  Click aquí para acceder
                </small>
              </div>

            </b-list-group-item>
          </transition>
        </div>
      </b-list-group>
    </b-tab>
  </b-tabs>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import { mapGetters } from 'vuex';

export default {
  name: 'DefaultAside',
  components: {
    cSwitch
  },
computed: {
    // ...mapFields([
    //   'mensajes',
    // ]),

    ...mapGetters('mensajes', ['mensajes', 'mensajesNoLeidos']),
  },
  mounted() {
    this.$store.dispatch('mensajes/getMensajes')
      .catch( error => this.showErrorMsj (error));
  },
  methods: {
    refresh() {
    },
    setLeido(params) {
      if (params.leido) {
        this.$store.dispatch('mensajes/setMensajeNoLeido', params.id)
          .catch( error => this.showErrorMsj (error));
      } else {
        this.$store.dispatch('mensajes/setMensajeLeido', params.id)
          .catch( error => this.showErrorMsj (error));
      }
    },
    borrarMensaje(mensajeId) {
      this.$store.dispatch('mensajes/delete', mensajeId)
          .catch( error => this.showErrorMsj (error));
    },
    goTo(params) {
      let paramsObj = {};
      if (params.params && typeof params.params === 'string') {
        // Dividir por comas y procesar cada par clave:valor
        params.params.split(',').forEach(param => {
          const [key, value] = param.split(':').map(item => item.trim());
          if (key && value) {
            // Intentar convertir números
            paramsObj[key] = isNaN(value) ? value : Number(value);
          }
        });
      } else if (params.params && typeof params.params === 'object') {
        paramsObj = params.params;
      }

      if (!params.leido) {
        this.$store.dispatch('mensajes/setMensajeLeido', params.id)
          .catch( error => this.showErrorMsj (error))
          .finally(() => {
            document.body.classList.toggle('aside-menu-show');

            this.$router.push({ name: params.ruta, 
                                params: { ...paramsObj }});
          })
      } else {
        document.body.classList.toggle('aside-menu-show');

        this.$router.push({ name: params.ruta, 
                            params: { ...paramsObj }});
      }
    }
  }  
}
</script>

<style>
  .mensajes .content {
    display: block;
  }
  .mensajes .header,
  .mensajes .header p {
    display: inline-block;
  }
  .mensajes .header p {
    margin-bottom: 5px;
  }
  .mensajes i {
    cursor: pointer;
    margin-right: 8px;
  }
  .mensajes i.fa-circle {
    margin-right: 8px;
  }
  .mensajes i.fa-circle.leido {
    color: gray;
  }
  .mensajes i.fa-circle.no-leido {
    color: red;
  }
  .mensajes i.fa-trash-o {
    /* margin-left: 15px; */
    color: red;
    display: none;
  }
  .mensajes .list-group-item:hover i.fa-trash-o {
    position: absolute;
    display: block;
    top: 20px;
    right: 20px;
  }
  .mensajes .link {
    margin-top: 5px;
  } 
  .mensajes .link small {
    cursor: pointer;
    font-style: italic;
    color: rgba(32, 168, 216, 0.8);
  } 
  .mensajes .link small:hover {
    color: rgb(32, 168, 216);
  } 

</style>